import { render, staticRenderFns } from "./CreateTechnician.vue?vue&type=template&id=3294425e&"
import script from "./CreateTechnician.vue?vue&type=script&lang=js&"
export * from "./CreateTechnician.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports